import React, { forwardRef, useMemo } from 'react'
import cx from 'classnames'
import { useAppSelector } from 'reduxTyped'
import { AvatarRound, Link, sanitizeURL } from '@manychat/manyui'

import { getInstagramChannel } from 'common/core/selectors/channelSelectors'

import { mapTextToContentArray } from './lib/mapTextToContentArray'

import cm from './MessageBubble.module.css'

export enum MessageType {
  RECEIVED = 'RECEIVED',
  SENT = 'SENT',
  TYPING = 'TYPING',
}

interface MessageBubbleProps {
  type: MessageType
  text?: string
}

export const MessageBubble = forwardRef<HTMLLIElement, MessageBubbleProps>(
  ({ type, text }: MessageBubbleProps, ref) => {
    const { avatar } = useAppSelector(getInstagramChannel)

    const result = useMemo(() => {
      if (!text) {
        return [{ type: 'text', content: '' }]
      }

      return mapTextToContentArray(text)
    }, [text])

    const showAvatar = type === MessageType.RECEIVED || type === MessageType.TYPING

    return (
      <li
        ref={ref}
        className={cx(cm.wrapper, {
          [cm.received]: type === MessageType.RECEIVED,
          [cm.sent]: type === MessageType.SENT,
          [cm.typing]: type === MessageType.TYPING,
        })}
      >
        {showAvatar && <AvatarRound alt="user avatar" size="small" src={avatar} />}

        <p className={cm.text}>
          {type !== MessageType.TYPING &&
            result.map((chunk, index) => {
              if (chunk.type === 'link') {
                return (
                  <Link
                    key={index}
                    className={cm.link}
                    href={sanitizeURL(chunk.content)}
                    target="_blank"
                  >
                    {chunk.content}
                  </Link>
                )
              }

              return <span key={index}>{chunk.content}</span>
            })}

          {type === MessageType.TYPING && (
            <>
              <span>.</span>
              <span>.</span>
              <span>.</span>
            </>
          )}
        </p>

        <div className={cm.spacer} />
      </li>
    )
  },
)
